export const Leftarr = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13 14.5858L10.4142 12L13 9.41421V14.5858Z" fill="#242424" stroke="#64748B" strokeWidth="2" />
  </svg>
);
